export default __webpack_public_path__ + "static/media/24.fea070d0.png";